import { Provider } from 'react-redux';

import Router from './Router';
import { history, store } from './store';
import { StylesProvider } from '@material-ui/core/styles';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ConnectedRouter } from 'connected-react-router';
import { basicLogger, withLDProvider } from 'launchdarkly-react-client-sdk';

import { Environment } from '@cobliteam/react-environments';

import Alert, { AlertContainer } from '@cobliteam/ui/components/Alert';
import { TooltipProvider } from '@cobliteam/ui/components/Tooltip';
import { APIProvider } from '@vis.gl/react-google-maps';

const env = Environment.getInstance().getEnvironment();

const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onSuccess: (data, variables, context, mutation) => {
      if (mutation.meta?.successMessage) {
        Alert.success((mutation.meta?.successMessage as string) || 'Sucesso ao carregar dados');
      }
    },
    onError: (data, variables, context, mutation) => {
      if (mutation.meta?.errorMessage) {
        Alert.error((mutation.meta?.errorMessage as string) || 'Erro ao carregar dados');
      }
    },
  }),
  queryCache: new QueryCache({
    onSuccess: (data, query) => {
      if (query.meta?.successMessage) {
        Alert.success((query.meta?.successMessage as string) || 'Sucesso ao carregar dados');
      }
    },
    onError: (data, query) => {
      if (query.meta?.errorMessage) {
        Alert.error((query.meta?.errorMessage as string) || 'Erro ao carregar dados');
      }
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const App = () => {
  return (
    <StylesProvider injectFirst>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <APIProvider apiKey={env.googleMapsVectorKey}>
            <TooltipProvider delayDuration={300}>
              <ConnectedRouter history={history}>
                <Router />
                <AlertContainer richColors position='top-right' pauseWhenPageIsHidden />
              </ConnectedRouter>
            </TooltipProvider>
          </APIProvider>
        </Provider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </StylesProvider>
  );
};

export default withLDProvider({
  clientSideID: env.launchDarklyId,
  options: {
    logger: basicLogger({ level: 'none' }),
  },
})(App);
